import { render } from "./InternalTransferForm.vue?vue&type=template&id=72114b06&ts=true"
import script from "./InternalTransferForm.vue?vue&type=script&lang=ts"
export * from "./InternalTransferForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__